import triggerTracking from '@blueprint/tracking/dist/Tracking';
import {
    ActionAfterAuth,
    AuthModalTracking,
    Segment
} from 'shared/components/AuthModal/AuthModal.types';
import RegistrationFormData from './interfaces/RegistrationFormData';
import { RegisterUserPayload } from '../../../queries/authentication/authentication';
import { authTaxonomyObject } from './constants/taxonomy';
import { trackAuthSegmentEvent } from './utils/segmentTrack';

type TrackAuthSubmit = (props: {
    payload: RegisterUserPayload;
    formData: RegistrationFormData;
    eventLabel?: ActionAfterAuth['eventLabel'];
    segment?: Segment | undefined;
}) => Array<Promise<void>>;

export const trackAuthSubmit: TrackAuthSubmit = ({
    payload,
    formData,
    eventLabel = 'registration_modal',
    segment
}) => {
    const { situation, consent__insights__24 } = formData;
    const { success, errorCode } = payload;

    if (errorCode === 'EMAIL_EXISTS') {
        triggerTracking({
            event: 'GAEvent',
            eventCategory: 'registration',
            eventAction: 'failure_account_exists',
            eventLabel
        });
    }

    if (!success) return [];

    triggerTracking<AuthModalTracking>({
        event: 'GAEvent',
        eventCategory: 'registration',
        eventAction: 'success',
        eventLabel,
        taxonomy: authTaxonomyObject.zpg.register
    });
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'registration',
        eventAction: 'about_me',
        eventLabel: situation ? situation : 'blank'
    });

    const tracking = [];

    tracking.push(trackAuthSegmentEvent('reg', segment));

    if (consent__insights__24 !== undefined) {
        triggerTracking({
            event: 'GAEvent',
            eventCategory: 'permission opt-in',
            eventAction: consent__insights__24 ? 'optin_both' : 'optin_neither',
            eventLabel
        });

        if (consent__insights__24) {
            tracking.push(trackAuthSegmentEvent('optin', segment));
        }
    }

    return tracking;
};
